import { useEffect, useState } from 'react'

import { useUser } from '@/widgets/user'

import { removeItemsFromCart, useCart } from '@/entities/cart'
import { checkNoEntityProducts, getProductListString } from '@/entities/product'
import { UserType } from '@/entities/user'

export const useRemoveEntityProducts = () => {
	const { isJuridicalUser, changeUserType } = useUser()
	const { products, getCartInfoWithEvents } = useCart()
	const [isModalVisible, setModalVisible] = useState<boolean>(false)

	useEffect(() => {
		if (isJuridicalUser && checkNoEntityProducts(products)) {
			setModalVisible(true)
		}
	}, [isJuridicalUser, products])

	const handleOk = async () => {
		setModalVisible(false)

		if (checkNoEntityProducts(products)) {
			const params = getProductListString(products)
			await removeItemsFromCart(params)
		}

		await getCartInfoWithEvents()
	}

	const handleCancel = () => {
		setModalVisible(false)
		changeUserType(UserType.Individual, `.iport.ru`)
	}

	return {
		shouldShowModal: isModalVisible,
		onOk: handleOk,
		onCancel: handleCancel
	}
}
